<template>
  <div class="live-guarantee-pool-container" v-loading="loading">
    <live-guarantee-search ref="search" @search="handelSearch">
      <el-button icon="el-icon-download" type="primary"
                 slot="downLoad"
                 :disabled="downloadLoading"
                 :loading="downloadLoading"
                 @click="exportExcel">
        {{ downloadLoading ? '导出中...' : '导出' }}
      </el-button>
      <el-button v-permission="'live_guarantee__un_claim_rebate'" icon="el-icon-remove" type="primary"
                 v-if="search.range!=='wait_by_rebate'" slot="rebate" style="background: #e03f3d;margin-left: 10px;"
                 @click="handleBatchGiveUp">
        批量撤回认领
      </el-button>
    </live-guarantee-search>
    <div class="live-guarantee-pool-container__content default-table" :style="`height:${height_content}`">
      <div class="toolbar"
           style="display: flex;justify-content: space-between;align-items: center;position:absolute;z-index: 9;left: 80px;width: calc(100% - 110px);border-bottom: unset">
        <div>
          <el-radio-group v-model="search.range" size="mini" style="margin-right: 20px;">
            <el-radio-button label="wait_by_rebate">待认领</el-radio-button>
            <el-radio-button label="mine_by_rebate">我认领的</el-radio-button>
            <el-radio-button label="null">全部</el-radio-button>
          </el-radio-group>
          <span>共有&nbsp;{{ search.total }}&nbsp;直播保量数据</span>
          <el-tooltip
              content="总额度即目标投放金额。完成额度为对应签约时间区间内该客户/集团投放金额（含税收入）总和。"
              placement="right" effect="light">
            <span style="color: #AAAAAA;margin-left: 10px;cursor: pointer;">
                 数据说明<i class="el-icon-info"/>
            </span>
          </el-tooltip>
        </div>
      </div>
      <el-table ref="table" :data="table" height="calc(100% - 42px)" class="live-guarantee-pool_table"
                v-loading="downloadLoading"
                element-loading-text="准备下载中..."
                @selection-change="getSelection" style="width: 100%">
        <el-table-column type="selection" width="50"/>
        <el-table-column>
          <template v-slot="{row:{date_live,artist_name,artist_no,rebate_is_claim,platform}}">
            <span v-if="MapStatus[rebate_is_claim]"
                  class="tag"
                  :style="{color:MapStatus[rebate_is_claim].color,background:MapStatus[rebate_is_claim].bg_color}">
                {{ MapStatus[rebate_is_claim].label }}
            </span>
            <div style="margin-top: 8px;">月份：<span>{{ date_live|parseTime('{y}年{m}月') }}</span></div>
            <div>红人昵称：<span>{{ artist_name }}</span></div>
            <div>平台：<span>{{ platform }}</span></div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{shop_name,product_name,source_traffic}}">
            <div>店铺：<span>{{ shop_name }}</span></div>
            <div>商品名称：<span>{{ product_name || '-' }}</span></div>
            <div>流量来源：<span>{{ source_traffic || '-' }}</span></div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{sales_volume,settlement_amount,commission_income,commission_rate}}">
            <div>订单数：<span>{{ sales_volume|numberFormat }}</span></div>
            <div>结算金额：<span>￥{{ settlement_amount|numberFormat(2) }}</span></div>
            <div>佣金收入：<span>￥{{ commission_income|numberFormat(2) }}</span></div>
            <div>佣金比例：<span>{{ commission_rate|numberFormat(2) }}%</span></div>
          </template>
        </el-table-column>
        <!--        <el-table-column>-->
        <!--          <template v-slot="{row:{claim_or,claim_at,confirm_at,order_no}}">-->
        <!--            <div v-if="order_no">-->
        <!--              认领全案：-->
        <!--              <span><to-order-detail by-field="order_no" :order="{order_no}"/></span>-->
        <!--            </div>-->
        <!--            <div>认领归属：<span>{{ claim_or || '-' }}</span></div>-->
        <!--            <div>认领时间：<span>{{ claim_at|parseTime('{y}/{m}/{d} {h}:{i}') }}</span></div>-->
        <!--            <div>确认时间：<span>{{ confirm_at|parseTime('{y}/{m}/{d} {h}:{i}') }}</span></div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column>
          <template v-slot="{row:{rebate_order_no,rebate_claim_at,rebate_claim_or,order_no}}">
            <div>认领归属：<span>{{ rebate_claim_or || '-' }}</span></div>
            <div>认领时间：<span>{{ rebate_claim_at|parseTime('{y}/{m}/{d} {h}:{i}') }}</span></div>
            <div v-if="order_no">
              全案保量订单号:
              <span><to-order-detail by-field="order_no" :order="{order_no}"/></span>
            </div>
            <!--            <div>全案保量订单号：<span><to-order-detail by-field="order_no" :order="{order_no}"/></span></div>-->
          </template>
        </el-table-column>
        <el-table-column width="120" align="center">
          <!--          live_guarantee__all_un_claim_rebate-->
          <template v-slot="{row:{id,rebate_is_claim}}">
            <el-button v-permission="'live_guarantee__un_claim_rebate'"
                       v-if="rebate_is_claim===StatusClaim&&search.range!=='null'" size="small" round
                       @click="handleGiveUp([id])">
              撤回认领
            </el-button>
            <el-button v-permission="'live_guarantee__all_un_claim_rebate'"
                       v-if="rebate_is_claim===StatusClaim&&search.range==='null'" size="small" round
                       @click="handleGiveUp([id])">
              撤回认领
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px;display: flex;align-items: center;justify-content: space-between;">
        <div style="width: calc(100% - 250px)">
          <live-guarantee-store-commission v-permission="'live_guarantee__claim_rebate'" :get-selection="getSelection"
                                           v-if="search.range!=='mine_by_rebate'" :order-no="order_no"
                                           @success="handelSearch"/>
          <span style="margin-left: 20px;">已选中 <b>{{ summary.rows }}</b> 行</span>
          <span style="margin-left: 20px;">总结算金额：￥<b>{{ summary.settlement_amount|numberFormat(2) }}</b></span>
          <span style="margin-left: 20px;">总佣金收入：￥<b>{{ summary.commission_income|numberFormat(2) }}</b></span>
        </div>
        <el-pagination
            background
            :current-page="search.page"
            :page-sizes="[5,10,20,100, 200, 300, 400]"
            :page-size="search.page_size"
            layout="total, sizes, prev, pager, next"
            :total="search.total"
            style="float: right;"
            @current-change="handleCurrentChange"
            @size-change="eventSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {liveGuaranteeList, liveGuaranteeUnByRebate} from "@/api/liveGuarantee";
// import LiveGuaranteeStoreClaim from "./component/claim.vue";
import LiveGuaranteeStoreCommission from "./component/commission.vue";
import {MapStatus, StatusClaim, StatusWait} from "./index";
import LiveGuaranteeSearch from "./component/search-commission.vue";
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";
import XLSX from "xlsx";
import {roundToTwo} from "@/utils";

export default {
  name: "LiveGuaranteePool",
  components: {ToOrderDetail, LiveGuaranteeSearch, LiveGuaranteeStoreCommission},
  data() {
    return {
      height_content: 'calc(100% - 48px - 77px - 80px)',
      MapStatus,
      StatusClaim,
      order_no: '',
      table: [],
      summary: {
        rows: 0,
        commission_income: 0,
        settlement_amount: 0,
      },
      loading: false,
      search: {
        page: 1,
        page_size: 20,
        total: 0,
        order_by: null,
        range: 'wait_by_rebate',
      },
      downDataList: [],
      downloadLoading: false,
      total: 0
    }
  },
  watch: {
    "search.range"() {
      this.handelSearch()
    }
  },
  created() {
    this.init()
  },
  beforeMount() {
    window.addEventListener('resize', this.handelResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handelResize)
  },
  methods: {
    handleBatchGiveUp: function () {
      const data = this.getSelection()
      if (data.length < 1) {
        this.$message.warning('请选择要撤回认领的行！')
        return;
      }
      let error = false
      const ids = data.map(_ => {
        if (_.rebate_is_claim !== StatusClaim) {
          error = `${_.artist_name}，${_.shop_name} 没有认领！不可撤回认领`
        }
        return _.id
      })
      if (error) {
        this.$message.warning(error)
        return;
      }
      this.handleGiveUp(ids)
    },
    handleGiveUp: function (ids) {
      this.$msgbox.confirm('确定撤回认领吗?此操作后数据将变成（待认领）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {success} = await liveGuaranteeUnByRebate({ids})
        if (success) {
          this.$message.success('操作成功！')
          this.handelSearch()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    getSelection: function () {
      const selection = this.$refs.table.selection
      let commission_income = 0
      let settlement_amount = 0
      selection.map(_ => {
        commission_income += parseFloat(_.commission_income + '')
        settlement_amount += parseFloat(_.settlement_amount + '')
      })
      this.summary = {
        commission_income,
        settlement_amount,
        rows: selection.length,
      }
      return selection
    },
    handelResize() {
      this.$nextTick(() => {
        const dom = this.$refs.search
        this.height_content = `calc(100% - 48px - ${dom.$el.offsetHeight}px - 10px)`
      })
    },
    init: function () {
      this.order_no = this.$route.query.order_no || '';
      this.$nextTick(() => {
        this.$refs.search.search.artist_id = this.$route.query.artist_id || '';
        this.getData()
        this.handelResize()
      })
    },
    handleCurrentChange: function (val) {
      this.search.page = val
      this.getData()
    },
    eventSizeChange: function (page_size) {
      this.search.page_size = page_size
      this.handelSearch()
    },
    handelSearch: function () {
      this.search.page = 1
      this.getData()
    },
    eventSort: function (field, sort) {
      this.search.order_by = field ? `${field} ${sort}` : ''
      this.handelSearch()
    },
    getData: async function () {
      this.loading = true
      if (!this.$refs.search) {
        return;
      }
      const params = {...this.search, ...this.$refs.search.getSearch()}
      if (params && params.range === 'null') {
        delete params.range
      }
      const {model: {data, total}} = await liveGuaranteeList(params)
      this.loading = false
      this.search.total = total || 0
      this.table = data || []
    },
    selectable: function (row) {
      return row.status === StatusWait
    },
    async exportExcel() {
      this.downDataList = []
      this.downloadLoading = true
      // 记录导出信息
      await this.getAllData()
    },
    async getDownList(pageData) {
      const params = {...this.search, ...this.$refs.search.getSearch(), ...pageData}
      if (params && params.range === 'null') {
        delete params.range
      }
      let list = []
      let page_info = {}
      const {model: {data, total, current_page}} = await liveGuaranteeList(params)
      list = data
      page_info = {
        page: current_page,
        current_page: current_page,
        total: total
      }
      this.total = total
      if (page_info.current_page === 1 && list.length === 0) {
        this.$message.error('暂无数据')
        this.downloadLoading = false
        return false
      }
      this.downDataList = [...this.downDataList, ...list]
      // eslint-disable-next-line require-atomic-updates
      pageData.total = page_info.total
      // eslint-disable-next-line require-atomic-updates
      pageData.current_page = page_info.current_page
      //
      if (this.downDataList.length < pageData.total) {
        pageData.page++
        await this.getDownList(pageData)
      } else {
        // 数据加载完毕，通知后台记录导出行为
        // 记录导出信息
        // await this.endRecordExport()
        return true
      }
    },
    async getAllData() {
      const pageData = {
        page_size: 500,
        page: 1,
        total: this.total
      }
      await this.getDownList(pageData)

      if (this.downDataList.length !== 0 && this.downDataList.length === pageData.total) {
        /* 生成工作表 */
        const workbook = XLSX.utils.book_new()
        const header = ['月份', '平台', '达人账号', '达人昵称[以星广汇昵称为准]', '商品名称', '流量来源', '店铺名称', '订单数',
          '结算金额', '总佣金收入', '佣金比例(%)', '招商负责人', '全案保量单号']
        const data = this.downDataList.map((item) => {
          return {
            '月份': item.date_live,
            '平台': item.platform,
            '达人账号': item.artist_no || '',
            '达人昵称[以星广汇昵称为准]': item.artist_name,
            '商品名称': item.product_name || '',
            '流量来源': item.source_traffic || '',
            '店铺名称': item.shop_name || '',
            '订单数': item.sales_volume,
            '结算金额': roundToTwo(item.settlement_amount || 0),
            '总佣金收入': roundToTwo(item.commission_income || 0),
            '佣金比例(%)': roundToTwo(item.commission_rate || 0),
            '招商负责人': item.rebate_claim_or || '暂无',
            '全案保量单号': item.order_no || '',
          }
        })
        let ws = XLSX.utils.json_to_sheet(data, {header: header})
        ws = this.worksheetStyle(ws)
        XLSX.utils.book_append_sheet(workbook, ws, '直播佣金认领')
        XLSX.writeFile(workbook, `直播佣金认领【${this.search.range === 'null' ? '全部' : this.search.range === 'wait_by_rebate' ? '待认领' : '我认领的'}】列表.xlsx`)
        this.loadingEnd = true
        setTimeout(() => {
          this.downloadLoading = false
        }, 2000)
      }
    },
    worksheetStyle: function (worksheet) {
      // 表样式设置
      const colsLength = 22
      const cols = [] // 设置每列的宽度
      // wpx 字段表示以像素为单位，wch 字段表示以字符为单位
      for (let i = 0; i <= colsLength; i++) {
        const col = {}
        if (i === 0) {
          col.wch = 10
        } else if (i === 3) {
          col.wch = 40
        } else {
          col.wch = 20
        }
        cols.push(col)
      }
      worksheet['!cols'] = cols // 设置列宽信息到工作表
      // 以下是样式设置，样式设置放在组织完数据之后，xlsx-js-style的核心API就是SheetJS的
      Object.keys(worksheet).forEach(key => {
        // 非!开头的属性都是单元格
        if (!key.startsWith('!')) {
          if (['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1'].includes(key)) {
            worksheet[key].s = {
              font: {
                sz: '12',
                name: 'Microsoft YaHei'
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
              },
              fill: {
                fgColor: {rgb: 'fce2eb'}
              }
            }
            worksheet[key].t = 's'
          } else {
            worksheet[key].s = {
              font: {
                sz: '14'
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
              }
            }
            worksheet[key].t = 'n'
          }
        }
      })

      return worksheet
    },
  }
}
</script>
<style lang="scss">
@import "./index";

</style>
